<template>
    <div>
      <v-alert
        v-model="alert_transport"
        color="secondary"
        icon="mdi-truck"
        closable
        text="Darmowa dostawa kurierem i paczkomatem na terenie całej Polski!"
      ></v-alert>
      <br />
      <v-row v-bind:class="marginesy">
        <v-col cols="1"></v-col>
        <v-col cols="10">
          <p v-if="mobile==false" class="text-h3 text-primary">Dane zamawiającego</p>
          <p v-if="mobile==true" class="text-h5 text-primary">Dane zamawiającego</p>
          <br />
          <v-form ref="valid">
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="name"
                :rules="fieldRules"
                label="Imię"
                required
                variant="outlined"
                density="comfortable"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="surname"
                :rules="fieldRules"
                label="Nazwisko"
                required
                variant="outlined"
                density="comfortable"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="Adres E-Mail"
                required
                variant="outlined"
                density="comfortable"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md='6'>
              <v-text-field
                v-model="phonenum"
                :rules="fieldRules"
                label="Nr telefonu"
                required
                type="number"
                variant="outlined"
                density="comfortable"
              ></v-text-field>
            </v-col>
          </v-row>
          <br />
          <p class=text-h6> Adres wysyłki </p>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="address"
                :rules="fieldRules"
                label="Ulica"
                required
                variant="outlined"
                density="comfortable"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="addnum"
                :rules="fieldRules"
                label="Numer Domu"
                required
                variant="outlined"
                density="comfortable"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="addnum2"
                label="Numer Mieszkania"
                type="number"
                variant="outlined"
                density="comfortable"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="city"
                :rules="fieldRules"
                label="Miasto"
                required
                variant="outlined"
                density="comfortable"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="zipcode"
                :rules="zipRules"
                label="Kod pocztowy"
                required
                variant="outlined"
                density="comfortable"
                placeholder="00-000"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="voivodeshipval"
                :rules="fieldRules"
                label="Województwo"
                :items="voivodeship"
                required
                variant="outlined"
                density="comfortable"
              ></v-select>
            </v-col>
          </v-row>

          <v-checkbox v-model="fakturaVATcheck" label="Dane do faktury takie same jak do wysyłki?"></v-checkbox>
<!-- Formularz dla Fakturowiczów -->
          <div v-if="fakturaVATcheck !== true">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="FVfirm"
                  :rules="fieldRules"
                  label="Firma"
                  variant="outlined"
                  density="comfortable"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="FVnip"
                  :rules="fieldRules"
                  label="NIP"
                  type="number"
                  variant="outlined"
                  density="comfortable"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="FVname"
                  :rules="fieldRules"
                  label="Imię"
                  required
                  variant="outlined"
                  density="comfortable"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="FVsurname"
                  :rules="fieldRules"
                  label="Nazwisko"
                  required
                  variant="outlined"
                  density="comfortable"
                ></v-text-field>
              </v-col>
            </v-row>
            <br />
            <p class=text-h6> Adres </p>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="FVaddress"
                  :rules="fieldRules"
                  label="Ulica"
                  required
                  variant="outlined"
                  density="comfortable"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="FVaddnum"
                  :rules="fieldRules"
                  label="Numer Domu"
                  required
                  variant="outlined"
                  density="comfortable"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="FVaddnum2"
                  label="Numer Mieszkania"
                  type="number"
                  variant="outlined"
                  density="comfortable"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="FVcity"
                  :rules="fieldRules"
                  label="Miasto"
                  required
                  variant="outlined"
                  density="comfortable"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="FVzipcode"
                  :rules="zipRules"
                  label="Kod pocztowy"
                  required
                  variant="outlined"
                  density="comfortable"
                  placeholder="00-000"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="FVvoivodeshipval"
                  :rules="fieldRules"
                  label="Województwo"
                  :items="voivodeship"
                  required
                  variant="outlined"
                  density="comfortable"
                ></v-select>
              </v-col>
            </v-row>
          </div>

          <br />
          <p class=text-h6> Sposób dostawy </p>
          <v-radio-group v-model="deliveryoption" required :rules="fieldRules">
            <v-radio label="Kurier" value="Kurier"></v-radio>
            <v-radio label="Poczta Polska" value="Poczta Polska"></v-radio>
            <v-radio label="Paczkomat" value="Paczkomat"></v-radio>
          </v-radio-group>
          </v-form>
          <div v-if="deliveryoption == 'Paczkomat'">
            <div v-if="mobile == false">
              Wybrany paczkomat: {{ deliverypaczkomat }}
              <p v-if="nopaczkochosen==true" class="text-subtitle-2 text-red">Nie wybrano paczkomatu</p>
              <div v-html="inposttest" class="map-style"></div>
            </div>
            <div v-if="mobile == true">
              Wybrany paczkomat: {{ deliverypaczkomat }}
              <p v-if="nopaczkochosen==true" class="text-subtitle-2 text-red">Nie wybrano paczkomatu</p>
              <v-btn
                color="primary"
                @click="overlay = !overlay"
                variant='outlined'
              >
                Pokaż mapę paczkomatów
              </v-btn>
              <v-overlay v-model="overlay" width="100%">
                  <v-row justify="end" class="ma-2">
                    <v-btn color="white" icon="mdi-close" @click="this.overlay=!this.overlay"></v-btn>
                  </v-row>                
                  <div v-html="inposttest" class="map-style-mob"></div>
              </v-overlay>
            </div>
          </div>
          <v-row class="mt-8 justify-center">
            <v-btn color="primary" @click="formValid()">Przejdź do podsumowania</v-btn>
          </v-row>
        </v-col>
        <v-col cols="1"></v-col>
      </v-row>
    </div>
</template>

<script>  
  import { mapGetters, mapActions } from 'vuex';
  
  export default {
    data: () => ({
      inposttest: `<inpost-geowidget
            id="geowidget"
            onpoint="onpointselect"
            token='eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJzQlpXVzFNZzVlQnpDYU1XU3JvTlBjRWFveFpXcW9Ua2FuZVB3X291LWxvIn0.eyJleHAiOjIwMTkwNTc3MjgsImlhdCI6MTcwMzY5NzcyOCwianRpIjoiMzdmNTM4OTItM2FhNC00NTcwLWI2MDctY2ZhYjUyMjljYmNkIiwiaXNzIjoiaHR0cHM6Ly9sb2dpbi5pbnBvc3QucGwvYXV0aC9yZWFsbXMvZXh0ZXJuYWwiLCJzdWIiOiJmOjEyNDc1MDUxLTFjMDMtNGU1OS1iYTBjLTJiNDU2OTVlZjUzNTpjdzYxQTc5Q1FaSllDQ3lSZU84ZG9aT1RId3VwMnZPYm5nelkwWnBmdkQwIiwidHlwIjoiQmVhcmVyIiwiYXpwIjoic2hpcHgiLCJzZXNzaW9uX3N0YXRlIjoiODhkMmQ1MGYtMjQxOC00MmM2LTgwZmEtZmI3ZTE4NDU3NjMxIiwic2NvcGUiOiJvcGVuaWQgYXBpOmFwaXBvaW50cyIsInNpZCI6Ijg4ZDJkNTBmLTI0MTgtNDJjNi04MGZhLWZiN2UxODQ1NzYzMSIsImFsbG93ZWRfcmVmZXJyZXJzIjoiYWxwYWtvd3lyYWoucGwiLCJ1dWlkIjoiNTJlN2RlNGMtNzI5Ny00YWU1LWEwZGMtODk2MDU2YTFhZGNhIn0.R49SXsaa7cOi5DawiBjs7VrO0k5QmDnLDp5snjlm6-Oqu5E3WcckDDZLErroluJwi-RLLPrI1SOZqXmeEQTiX-H8v8aqczHe5wOer4Nhx7rG02ONkvjMfrjYNdPjPluz1kb0l5pc7DYYOYkcA243dTuuMselNaZqehOjyt9vYlMsVmtEBttfF5G_UCD60X4kku90XCpL2zeRpY1FcjBNycm_B_0Dn9swG2dHw0X-ZdmJfozgA8ZUVFfvabXxQuNbm3lQKkG88hjD9wtlgQgBJh1lmnYD8CRqpBBbuO5Yh-n_Q_ffgnVPcIvWyCNV-wnca4KS4a1ccksGAQASvDkHlg' 
            language='pl' 
            config='parcelCollect'></inpost-geowidget>`,
      mobile: false,
      marginesy: '',
      name: '',
      surname: '',
      email: '',
      phonenum: '',
      address: '',
      addnum: '',
      addnum2: '',
      city: '',
      zipcode: '',
      msgSnackbar: false,
      voivodeship: ['dolnośląskie','kujawsko-pomorskie','lubelskie','lubuskie','łódzkie','małopolskie','mazowieckie','opolskie','podkarpackie','podlaskie','pomorskie','śląskie','świętokrzyskie','warmińsko-mazurskie','wielkopolskie','zachodniopomorskie'],
      voivodeshipval: '',
      fakturaVATcheck: true,
      FVfirm: '',
      FVnip: '',
      FVname: '',
      FVsurname: '',
      FVaddress: '',
      FVaddnum: '',
      FVaddnum2: '',
      FVcity: '',
      FVzipcode: '',
      FVvoivodeshipval: '',
      deliveryoption: '',
      deliverypaczkomat: '',
      nopaczkochosen: false,
      overlay: false,
      alert_transport: true,
      emailRules: [
        value => {
          if (value) return true

          return 'Pole jest wymagane.'
        },
        value => {
          if (/.+@.+\..+/.test(value)) return true

          return 'Podany adres E-mail jest nieprawidłowy.'
        },
      ],
      fieldRules: [
          value => {
            if (value) return true

            return 'Pole jest wymagane.'
          },
      ],
      zipRules: [
        value => {
          if (value) return true

          return 'Pole jest wymagane.'
        },
        value => {
          if (/(^\d{2}-\d{3}$)/.test(value)) return true

          return 'Podany kod pocztowy jest nieprawidłowy.'
        },
      ],
    }),
    computed: {
      ...mapGetters([
        'getProdInCart',
        'getUserData',
      ]),
    },
    created() {
      if(this.getProdInCart.length < 1){
        this.$router.push('/koszyk')
      }

      this.mobile = this.$vuetify.display.mobile
      if(this.$vuetify.display.mobile == false){
        this.marginesy = "ma-16"
      }
    },
    mounted() {
      let InPostGEO = document.createElement('script')
      InPostGEO.setAttribute('src', 'https://geowidget.inpost.pl/inpost-geowidget.js')
      document.head.appendChild(InPostGEO)

      this.ListentoInpost()
      this.timer = setInterval(() => { this.ListentoInpost() }, 10000)

      if(this.getUserData.length === 1){
        this.name = this.getUserData[0].name
        this.surname = this.getUserData[0].surname
        this.email = this.getUserData[0].email
        this.phonenum = this.getUserData[0].phonenum
        this.address = this.getUserData[0].address
        this.addnum = this.getUserData[0].address1
        this.addnum2 = this.getUserData[0].address2
        this.city = this.getUserData[0].city
        this.zipcode = this.getUserData[0].zipcode
        this.voivodeshipval = this.getUserData[0].voivodeship

        this.fakturaVATcheck = this.getUserData[0].FVcheckbox
        this.FVfirm = this.getUserData[0].FVfirm
        this.FVnip = this.getUserData[0].FVnip
        this.FVname = this.getUserData[0].FVname
        this.FVsurname = this.getUserData[0].FVsurname
        this.FVaddress = this.getUserData[0].FVaddress
        this.FVaddnum = this.getUserData[0].FVaddress1
        this.FVaddnum2 = this.getUserData[0].FVaddress2
        this.FVcity = this.getUserData[0].FVcity
        this.FVzipcode = this.getUserData[0].FVzipcode
        this.FVvoivodeshipval = this.getUserData[0].FVvoivodeshipval

        this.deliveryoption = this.getUserData[0].deliveryoption
        this.deliverypaczkomat = this.getUserData[0].deliverypaczkomat
      }
    },
    methods: {
      ...mapActions([
        'storeUserData',
      ]),
      async formValid() {
        const { valid } = await this.$refs.valid.validate()
        if(valid) {
          if(this.deliveryoption=="Paczkomat" && this.deliverypaczkomat=='') {
            this.nopaczkochosen = true;
          }else{
            if(this.deliveryoption=="Paczkomat"){
              this.deliveryoption = "Paczkomat ("+this.deliverypaczkomat+")"
            }
            this.pushBuyerData(this.name, this.surname, this.email, this.phonenum, this.address, this.addnum, this.addnum2, this.city, this.zipcode, this.voivodeshipval, this.fakturaVATcheck, this.FVfirm, this.FVnip, this.FVname, this.FVsurname, this.FVaddress, this.FVaddnum, this.FVaddnum2, this.FVcity, this.FVzipcode, this.FVvoivodeshipval, this.deliveryoption, this.deliverypaczkomat)
            this.$router.push('/podsumowanie')
          }
        }
      },
      pushBuyerData(name, surname, email, phonenum, address, addnum, addnum2, city, zipcode, voivodeshipval, FVcheckbox, FVfirm, FVnip, FVname, FVsurname, FVaddress, FVaddnum, FVaddnum2, FVcity, FVzipcode, FVvoivodeshipval, deliveryoption, deliverypaczkomat) {
        var data = {'name': name, 'surname': surname, 'email': email, 'phonenum': phonenum, 'address': address, 'address1': addnum, 'address2': addnum2, 'city': city, 'zipcode': zipcode, 'voivodeship': voivodeshipval, 
        'FVcheckbox': FVcheckbox, 'FVfirm': FVfirm, 'FVnip': FVnip, 'FVname': FVname, 'FVsurname': FVsurname, 'FVaddress': FVaddress, 'FVaddress1': FVaddnum, 'FVaddress2': FVaddnum2, 'FVcity': FVcity, 'FVzipcode': FVzipcode, 'FVvoivodeshipval': FVvoivodeshipval,
        'deliveryoption': deliveryoption, 'deliverypaczkomat': deliverypaczkomat}
        this.storeUserData(data);
        this.cart_snackbar = true;
      },
      ListentoInpost() {
        document.addEventListener('onpointselect', (event) => this.deliverypaczkomat = event.detail.name)
      }
    },
    beforeUpdate() {
      this.ListentoInpost()
    },
    watch: {
      deliverypaczkomat: function() {
        if(this.deliverypaczkomat!=''){
          this.nopaczkochosen = false;
          this.overlay = false;
        }
      }
    }
  }
</script>

<style>
  @import "https://geowidget.inpost.pl/inpost-geowidget.css";

  .map-style {
    height: 400px;
  }

  .map-style-mob {
    height: 800px;
  }
</style>